import type { JSX } from "react";
import { cn } from "./cn";

export interface TextButtonProps {
  /** Button label */
  readonly label: string;
  /** Color variant */
  readonly variant?: "accent" | "default";
  /** Extra className */
  readonly className?: string;
}

/**
 * A minimal text-only button (no background/border).
 */
export function TextButton({ label, variant = "accent", className }: TextButtonProps): JSX.Element {
  return (
    <button
      className={cn(
        "text-xs bg-transparent border-none cursor-pointer",
        variant === "accent" ? "text-accent" : "text-content-secondary",
        className,
      )}
      type="button"
    >
      {label}
    </button>
  );
}
